import { render } from "./ListeTypeRecettePage.vue?vue&type=template&id=7200acfa&ts=true"
import script from "./ListeTypeRecettePage.vue?vue&type=script&lang=ts"
export * from "./ListeTypeRecettePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__